<template>
    <div class="modal modal-blur fade show" id="modal-account" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="selectedProduct=='VOIP'">VOIP-Bestellung</h5>
                    <h5 class="modal-title" v-if="selectedProduct=='Fax2Mail'">Fax2Mail-Bestellung</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info" role="alert">
                        Du bist als {{ customer.display_name }} angemeldet und bestellst als {{ customer.business ? 'Businesskunde' : 'Privatkunde' }}.
                    </div>
                    <template v-if="step=='voip'">

                        <template v-if="selectedProduct=='VOIP'">
                            <label class="form-label font-weight-bold">Anzahl Gesprächskanäle*</label>
                            <select class="form-select " v-model="voipChannelsCount">
                                <option :value="null">Bitte wählen...</option>
                                <option v-for="index in 25" :key="index" :value="index">{{ index }}</option>
                            </select>
                            <div class="form-text">Ein Gesprächskanal bestimmt die Anzahl der gleichzeitig möglichen Gespräche.</div>
                        </template>

                        <template v-if="selectedProduct=='Fax2Mail'">
                            <label class="form-label font-weight-bold">E-Mail Adresse für Fax2Mail*</label>
                            <input class="form-control" v-model="emailFax" type="text">
                            <div class="form-text">An diese E-Mail-Adresse werden eingehende FAX-Nachrichten gesendet.</div>
                        </template>


                        <div class="mb-2 mt-2">
                            <label class="form-label font-weight-bold">Telefonbucheintrag erwünscht*</label>
                            <select class="form-select " v-model="phoneEntry">
                                <option :value="null">Bitte wählen...</option>
                                <option :value="true">Ja</option>
                                <option :value="false">Nein</option>
                            </select>
                        </div>

                        <div class="mb-2">
                            <label class="form-label font-weight-bold">Anzahl neuer Rufnummern*</label>
                            <select class="form-select " v-model="newNumbersCount">
                                <option :value="null">Bitte wählen...</option>
                                <option :value="0">Keine neue Rufnummer gewünscht</option>
                                <option v-for="index in 100" :key="index" :value="index">{{ index }}</option>
                            </select>
                            <div class="form-text">Wenn gewünscht, kannst du hier die Anzahl der neuen Nummern angeben.<br>
                                Wenn du eine bestehende Rufnummer übernehmen möchtest, gib die Anzahl 0 ein und wähle im nächsten Schritt die Portierung.

                            </div>
                        </div>
                    </template>

                    <template v-else-if="step=='port'">
                        <div class="mb-2">
                            <label class="form-label font-weight-bold">Portierung bestehender Rufnummern erwünscht*</label>
                            <select class="form-select " v-model="portNumbers">
                                <option :value="null">Bitte wählen...</option>
                                <option :value="true">Ja</option>
                                <option :value="false">Nein</option>
                            </select>
                            <div class="form-text">Falls du nur neue Nummern bestellen möchtest, wähle NEIN</div>
                        </div>


                        <template v-if="portNumbers===true">

                            <label class="form-label font-weight-normal  mb-0">Rufnummern*</label>
                            <template v-for="(portNumber, index) in portNumbersNumbers">
                                <div class="row g-2  mb-1" :key="`input_numbers_${index}`">
                                    <div class="col">
                                        <input class="form-control"   v-model="portNumber.number" placeholder="im Format +390474xxxxxx" type="text">
                                    </div>
                                    <div class="col-auto" v-if="index>0">
                                        <a href="#" class="btn btn-white btn-icon" aria-label="löschen" @click.prevent="portNumbersNumbers.splice(index, 1)">
                                        	<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <div class="mt-2">
                                <a href="#" @click.prevent="addPortNumber">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="9" /><line x1="9" y1="12" x2="15" y2="12" /><line x1="12" y1="9" x2="12" y2="15" /></svg>
                                    Weitere Rufnummer zur Portierung hinzufügen
                                </a>
                            </div>

                            <template v-if="portNumbersCount>0 || true">
                                <hr class="my-3">
                                <label class="form-label font-weight-bold">Angaben zum aktuellen Inhaber*</label>
                                <div class="mb-2">
                                    <label class="form-label font-weight-normal  mb-0">Aktueller Inhaber der Telefonlinie*</label>
                                    <select class="form-select " v-model="portNumbersSourceType">
                                        <option :value="null">Bitte wählen...</option>
                                        <option :value="'business'">Firmenkunde</option>
                                        <option :value="'private'">Privatkunde</option>
                                    </select>
                                </div>

                                <template v-if="portNumbersSourceType">
                                    <div class="mb-2">
                                        <label class="form-label font-weight-normal mb-0">Bisheriger Telefonprovider*</label>
                                        <select class="form-select " v-model="portNumbersSourceProvider">
                                            <option :value="null">Bitte wählen...</option>
                                            <option v-for="provider in voipCosts.number_porting_providers"  :value="provider" :key="provider.name">{{ provider.name }}</option>
                                        </select>
                                    </div>

                                    <div class="mb-2">
                                        <label class="form-label font-weight-normal mb-0">EXAKTER Name lt. letzter Telefonrechnung *</label>
                                        <input class="form-control" v-model="portNumbersSourceName" type="text">
                                    </div>

                                    <template v-if="portNumbersSourceType && portNumbersSourceType=='private'">
                                        <div class="mb-2">
                                            <label class="form-label font-weight-normal mb-0">Nummer Ausweisdokument *</label>
                                            <input class="form-control" v-model="portNumbersSourceDocumentId" type="text">
                                        </div>

                                        <div class="mb-2">
                                            <label class="form-label font-weight mb-0">Ausstellungsdatum Ausweisdokument *</label>
                                            <input placeholder="Im Format 20.01.2010" class="form-control" v-model="portNumbersSourceDocumentDate" type="text">
                                        </div>
                                    </template>

                                    <template v-if="portNumbersSourceType && portNumbersSourceType=='business'">
                                        <label class="form-label font-weight-normal mb-0">Gesetzlicher Vertreter*</label>
                                        <div class="row mb-2">
                                            <div class="col-6">
                                                <input placeholder="Vorname" class="form-control" v-model="portNumbersSourceFirstname" type="text">
                                                <div class="invalid-feedback"></div>
                                            </div>
                                            <div class="col-6">
                                                <input placeholder="Nachname" class="form-control" v-model="portNumbersSourceLastname" type="text">
                                                <div class="invalid-feedback"></div>
                                            </div>
                                        </div>
                                    </template>


                                    <div class="mb-2">
                                        <label class="form-label font-weight-normal mb-0">Steuernummer *</label>
                                        <input class="form-control" v-model="portNumbersSourceTaxNumber" type="text">
                                    </div>

                                    <div class="mb-2" v-if="portNumbersSourceType && portNumbersSourceType=='business'">
                                        <label class="form-label font-weight-normal mb-0">MwStr.Nr. *</label>
                                        <input class="form-control" v-model="portNumbersSourceVatNumber" type="text">
                                    </div>

                                    <label class="form-label font-weight-normal mb-0">Straße * (italienische Bezeichnung)</label>
                                    <div class="row mb-2">
                                        <div class="col-9">
                                            <input placeholder="Straße" class="form-control" v-model="portNumbersSourceStreet" type="text">
                                        </div>
                                        <div class="col-3">
                                            <input placeholder="Nr." class="form-control" v-model="portNumbersSourceStreetNumber" type="text">
                                        </div>
                                    </div>

                                    <div class="mb-2">
                                        <label class="form-label font-weight-normal mb-0">Gemeinde*</label>
                                        <select class="form-select " name="community" v-model="portNumbersSourceCommunityId">
                                            <option :value="null">Bitte wählen...</option>
                                            <option v-for="community in communities"  :value="community.id" :key="community.id">{{ community.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </template>



                        </template>
                        <template v-else>
                            <div class="alert alert-warning" v-if="portNumbers===false && newNumbersCount===0 && selectedProduct=='VOIP'">
                                Du hast keine neue Nummer bestellt und auch keine Portierung ausgewählt.<br>
                                Somit wird dir ein reiner SIP-Trunk zur Verfügung gestellt wo nur ausgehende Telefonate möglich sind.
                            </div>
                            <div class="alert alert-danger" v-if="portNumbers===false && newNumbersCount===0 && selectedProduct=='Fax2Mail'">
                                Du hast keine neue Nummer bestellt und auch keine Portierung ausgewählt.<br>
                                Diest ist für Fax2Mail nicht zulässig.
                            </div>
                        </template>
                    </template>

                    <template v-else-if="step=='data'">
                        <p>Aktivierungsort der VOIP-Linie.</p>
                        <label class="form-label font-weight-bold">Anschlussadresse - Straße*</label>
                        <div class="row mb-2">
                            <div class="col-9">
                                <input placeholder="Straße" class="form-control" v-model="street" name="street" type="text">
                                <div class="invalid-feedback"></div>
                            </div>
                            <div class="col-3">
                                <input placeholder="Nr." class="form-control" v-model="streetNumber" name="street_number" type="text">
                                <div class="invalid-feedback"></div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label font-weight-bold">Anschlussadresse - Gemeinde*</label>
                            <select class="form-select " name="community" v-model="communityId">
                                <option :value="null">Bitte wählen...</option>
                                <option v-for="community in communities"  :value="community.id" :key="community.id">{{ community.name }}</option>
                            </select>
                        </div>
                        <div class="mb-1">
                            <a href="#" @click.prevent="copyAddressFromInvoiceAddress">Aktivierungsort von Rechnungsadresse übernehmen</a>
                        </div>
                        <template>
                            <hr class="my-2">
                            <label class="form-label font-weight-normal">Ansprechpartner für die Installation*</label>
                            <div class="row mb-2">
                                <div class="col-6">
                                    <input placeholder="Vorname" class="form-control" v-model="firstname" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="col-6">
                                    <input placeholder="Nachname" class="form-control" v-model="lastname" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                            </div>
                            <label class="form-label font-weight-normal">E-Mail Adresse für Rückfragen*</label>
                            <input placeholder="E-Mail" class="form-control mb-2" v-model="email" type="email">

                            <label class="form-label font-weight-normal">Telefonnummer für Rückfragen*</label>
                            <input placeholder="Telefonnummer" class="form-control mb-2" v-model="phone" type="text">

                        </template>
                        <hr class="my-3">
                        <div class="mb-2">
                            <b>Rechnungsadresse</b><br>
                            {{ customer.name }}<br>
                            {{ customer.street }} {{ customer.street_number }}<br>
                            {{ customer.community_plz }} {{ customer.community_name }}<br>
                            Str.Nr.: {{ customer.tax_number }}<br>
                            <template v-if="customer.business">
                            MwStr.Nr.: {{ customer.vat_number }}<br>
                            </template>
                            Zahlung: SEPA Bankeinzug ({{ customer.bank_iban }})<br>
                            <small>Die Rechnungsadresse ist mit deinem Kundenaccount verknüpft.</small>
                        </div>
                    </template>
                    <template v-else>
                        <p>
                            Bitte prüfe die eingegebenen Daten auf Richtigkeit.<br>
                            <span v-if="!customer.business">Alle angezeigten Preise verstehen sich inkl. MwStr.</span>
                            <span v-if="customer.business">Alle angezeigten Preise verstehen sich exkl. MwStr.</span>
                        </p>


                        <div class="mb-2">
                            <b>Bestellung</b><br>
                            {{ selectedProduct }}<br>
                            Anzahl Gesprächskanäle: {{ voipChannelsCount }}<br>
                            Anzahl neue Nummern: {{ newNumbersCount }}<br>
                            Telefonbucheintrag gewünscht: {{ phoneEntry ? 'Ja' : 'Nein' }}
                        </div>

                        <div class="mb-2">
                            <p><b>Kostenübericht</b></p>
                            <ul class="ps-0 ms-0 list-unstyled">
                                <li>Monatliche Kosten: <b>{{ monthlyFee | currency }}</b></li>
                                <li v-if="existingNumberFee>0">Rufnummernmiete (monatlich): <b>{{ existingNumberFee | currency }}</b></li>
                                <li v-if="portNumberFee>0">Portierungskosten (einmalig): <b>{{ portNumberFee | currency }}</b></li>
                                <ul v-if="portNumbersSourceProvider && portNumbersSourceProvider.discount>0 && false">
                                    <li>Auf die Portierungskosten gibt es {{ portNumbersSourceProvider.discount }}% Rabatt</li>
                                </ul>
                                <li v-if="newNumberFee>0">Neue Nummern (einmalig): <b>{{ newNumberFee | currency }}</b></li>
                                <li v-if="hasFiberOrder">
                                    Einrichtungskosten entfallen, da Glasfaservertrag vorhanden<br>
                                </li>
                                <li v-else>
                                    Einrichtungskosten: <b>{{ voipCosts.voip_activation | currency }}</b><br>
                                </li>
                                <li>
                                    Vertragsbindung 24 Monate
                                </li>
                            </ul>
                        </div>

                        <div class="mb-2" v-if="community">
                            <b>Aktivierungsort</b><br>
                            {{ street }} {{ streetNumber }}<br>
                            {{ community.plz }} {{ community.name }}<br>
                        </div>

                        <div class="mb-2" v-if="portNumbers">
                            <b>Portierung</b><br>
                            {{ portNumbersSourceType=='private' ? 'Privatkunde' : 'Firmenkunde' }}<br>
                            Provider: {{ portNumbersSourceProvider.name }}<br>
                            {{ portNumbersSourceName }}<br>
                            <template v-if="portNumbersSourceType=='business'">
                                {{ portNumbersSourceFirstname }} {{ portNumbersSourceLastname }}<br>
                            </template>
                            Str.Nr.: {{ portNumbersSourceTaxNumber }}<br>
                            <template v-if="portNumbersSourceType=='business'">
                                MwStr.Nr.: {{ portNumbersSourceVatNumber }}<br>
                            </template>
                            Straße: {{ portNumbersSourceStreet }} {{ portNumbersSourceStreetNumber }}<br>
                            Ort: {{ portNumbersSourceCommunity.plz }} {{ portNumbersSourceCommunity.name }}<br>
                            <template v-if="portNumbersSourceType=='private'">
                                Ausweis: {{ portNumbersSourceDocumentId }} ({{ portNumbersSourceDocumentDate }})
                            </template>
                            <br>
                            Zu portierende Rufnummern: {{ portNumbersString }}
                        </div>

                        <div class="mb-2">
                            <b>Rechnungsadresse</b><br>
                            {{ customer.name }}<br>
                            {{ customer.street }} {{ customer.street_number }}<br>
                            {{ customer.community_plz }} {{ customer.community_name }}<br>
                            Str.Nr.: {{ customer.tax_number }}<br>
                            <template v-if="customer.business">
                            MwStr.Nr.: {{ customer.vat_number }}<br>
                            </template>
                            Zahlung: SEPA Bankeinzug ({{ customer.bank_iban }})<br>
                            <small>Die Rechnungsadresse ist mit deinem Kundenaccount verknüpft.</small>
                        </div>

                        <hr>
                        <label class="form-label">Optionale Bemerkung</label>
                        <textarea class="form-control" rows="3" v-model="notes"></textarea>
                        <label class="form-check mt-3">
                            <input class="form-check-input" v-model="agb" type="checkbox" :value="true">
                            <span class="form-check-label"> Ich habe die <a href="/agb" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.</span>
                        </label>
                    </template>


                </div>
                <div class="modal-footer">

                    <template v-if="step=='voip'">
                        <a href="#" class="btn btn-outline-danger" data-bs-dismiss="modal">
                            Abbrechen
                        </a>
                        <a href="#" class="btn btn-primary ms-auto" @click.prevent="nextStep">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="15" y1="16" x2="19" y2="12" /><line x1="15" y1="8" x2="19" y2="12" /></svg>
                            weiter
                        </a>
                    </template>
                    <template v-if="step=='port'">
                         <a href="#" class="btn btn-outline-danger" @click.prevent="step='voip'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="9" y2="16" /><line x1="5" y1="12" x2="9" y2="8" /></svg>
                            zurück
                        </a>
                        <a href="#" class="btn btn-primary ms-auto" @click.prevent="nextStep">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="15" y1="16" x2="19" y2="12" /><line x1="15" y1="8" x2="19" y2="12" /></svg>
                            weiter
                        </a>
                    </template>

                    <template v-if="step=='data'">
                         <a href="#" class="btn btn-outline-danger" @click.prevent="step='port'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="9" y2="16" /><line x1="5" y1="12" x2="9" y2="8" /></svg>
                            zurück
                        </a>
                        <a href="#" class="btn btn-primary ms-auto" @click.prevent="nextStep">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="15" y1="16" x2="19" y2="12" /><line x1="15" y1="8" x2="19" y2="12" /></svg>
                            weiter
                        </a>
                    </template>


                    <template v-if="step=='confirm'">
                         <a href="#" class="btn btn-outline-danger" @click.prevent="step='data'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="9" y2="16" /><line x1="5" y1="12" x2="9" y2="8" /></svg>
                            zurück
                        </a>
                        <a href="#" class="btn btn-primary ms-auto" @click.prevent="nextStep">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <line x1="10" y1="14" x2="21" y2="3" />
                                <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
                            </svg>
                            Bestellung senden
                        </a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    export default {
        props: ['customer', 'communities', 'voipCosts', 'hasFiberOrder'],
        mounted() {
            this.copyCustomerData()
        },
        data() {
            return {
                agb: false,
                street: null,
                streetNumber: null,
                communityId: null,
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                notes: null,

                step: 'voip',
                emailFax: null,
                portNumbers: null,
                portNumbersNumbers: [
                    {
                        number: null
                    }
                ],
                portNumbersSourceType: null,
                portNumbersSourceName: null,
                portNumbersSourceFirstname: null,
                portNumbersSourceLastname: null,
                portNumbersSourceProvider: null,
                portNumbersSourceTaxNumber: null,
                portNumbersSourceVatNumber: null,
                portNumbersSourceStreet: null,
                portNumbersSourceStreetNumber: null,
                portNumbersSourceCommunityId: null,
                portNumbersSourceDocumentId: null,
                portNumbersSourceDocumentDate: null,

                voipChannelsCount: null,
                phoneEntry: null,
                newNumbersCount: null,
            }
        },
        computed: {
            portNumbersString: function() {
                var tmp = []
                if(this.portNumbers !== true) {
                    return tmp;
                }
                this.portNumbersNumbers.forEach(item => {
                    tmp.push(item.number)
                })
                return tmp.join(', ')
            },
            existingNumberFee: function() {
                let count = this.portNumbersCount + this.newNumbersCount
                return this.voipCosts.existing_number_fee * count
            },
            portNumberFee: function() {
                if(this.portNumbers !== true) {
                    return 0;
                }
                var numberCosts = this.voipCosts.number_porting;
                if(this.portNumbersSourceProvider && this.portNumbersSourceProvider.discount > 0) {
                    numberCosts = numberCosts * (100-this.portNumbersSourceProvider.discount) / 100
                }

                var sum = numberCosts * this.portNumbersCount
                if(this.voipCosts.number_porting_max_total!==null) {
                    if(sum>this.voipCosts.number_porting_max_total) {
                        sum = this.voipCosts.number_porting_max_total
                    }
                }
                return sum;
            },
            newNumberFee: function() {
                var sum = this.voipCosts.new_number * this.newNumbersCount;
                return sum;
            },
            monthlyFee: function() {
                var sum = 0;
                if(this.$root.selectedProduct=='VOIP') {
                    sum += this.voipCosts.voip_channel  * this.voipChannelsCount
                }
                if(this.$root.selectedProduct=='Fax2Mail') {
                    sum += this.voipCosts.fax2mail_device
                }
                return sum;
            },
            portNumbersSourceCommunity: function() {
                if(this.portNumbersSourceCommunityId) {
                    return this.communities.find(item => {
                        return item.id==this.portNumbersSourceCommunityId
                    })
                }
                return null;
            },
            community: function() {
                return this.communities.find(item => {
                    return item.id==this.communityId
                })
            },
            portNumbersCount: function() {
                var count = 0
                if(this.portNumbers !== true) {
                    return 0;
                }
                this.portNumbersNumbers.forEach(item => {
                    if(item.number===null || item.number.length==0) {

                    } else {
                        count++;
                    }
                })
                return count;
            },
            selectedProduct: function() {
                if(this.$root.selectedProduct) {
                    return this.$root.selectedProduct
                }
                return null
            }
        },
        methods: {
            addPortNumber: function() {
                this.portNumbersNumbers.push({
                    number: null
                })
            },
            copyCustomerData: function() {
                this.firstname = this.customer.firstname;
                this.lastname = this.customer.lastname;
                this.phone = this.customer.phone;
                this.email = this.customer.email;


                this.emailFax = this.email;
                this.portNumbersSourceType = this.customer.business ? 'business' : 'private';
                this.portNumbersSourceTaxNumber = this.customer.tax_number;
                this.portNumbersSourceVatNumber = this.customer.vat_number;
                this.portNumbersSourceStreet = this.customer.street;
                this.portNumbersSourceStreetNumber = this.customer.street_number;
                this.portNumbersSourceCommunityId = this.customer.community_id;
                this.portNumbersSourceFirstname = this.customer.firstname
                this.portNumbersSourceLastname = this.customer.lastname
            },
            nextStep: function() {

                if(this.step=='voip') {
                    var errors = [];
                    if(this.voipChannelsCount==null && this.selectedProduct=='VOIP') {
                        errors.push('Die Anzahl der Gesprächkanäle muss eingegeben werden.')
                    }
                    if(this.phoneEntry==null) {
                        errors.push('Die Auswahl ob ein Telefonbucheintrag gewünscht ist muss getroffen werden.')
                    }
                    if(this.newNumbersCount==null) {
                        errors.push('Die Anzahl der gewünschten neuen Rufnummern muss getroffen werden.')
                    }
                    if(this.emailFax==null && this.selectedProduct=='Fax2Mail') {
                        errors.push('E-Mail Adresse für Fax2Mail muss angegeben werden.')
                    }
                    if(errors.length>0) {
                        Swal.fire({
                            title: 'Fehler',
                            html: errors.join("<br>"),
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return;
                    }
                    this.step = 'port';
                    jQuery("#modal-account").scrollTop(0);
                    return;
                }

                if(this.step=='port') {
                    var errors = [];

                    if(this.portNumbers==null) {
                        errors.push('Portierung erwünscht?')
                    }

                    if(this.portNumbers===false) {
                        if(this.portNumbers===false && this.newNumbersCount===0 && this.selectedProduct=='Fax2Mail') {
                            errors.push('Für Fax2Mail musst du entweder eine Portierung oder eine neue Nummer auswählen')
                        }
                    }

                    if(this.portNumbers===true) {
                        var check = true
                        this.portNumbersNumbers.forEach(item => {
                            if(item.number===null || item.number.length==0) {
                                check = false
                            } else {
                                if(!item.number.match(/^\+39[0-9]+$/)) {
                                    errors.push(`Die Telefonnummer "${item.number}" hat ein ungültiges Format`)
                                }
                            }
                        })
                        if(check==false) {
                            errors.push('Bei den Portierungs-Rufnummern sind leere Felder vorhanden')
                        }

                        if(this.portNumbersSourceType==null) {
                            errors.push('TYP Inhaber')
                        }
                        if(this.portNumbersSourceName==null) {
                            errors.push('Name lt. Telefonrechnung')
                        }
                        if(this.portNumbersSourceProvider==null) {
                            errors.push('Bisheriger Telefonprovider')
                        }
                        if(this.portNumbersSourceTaxNumber==null) {
                            errors.push('Steuernummer')
                        }
                        if(this.portNumbersSourceVatNumber==null && this.portNumbersSourceType=='business') {
                            errors.push('MwStr.Nr.')
                        }
                        if(this.portNumbersSourceStreet==null) {
                            errors.push('Straße')
                        }
                        if(this.portNumbersSourceStreetNumber==null) {
                            errors.push('Hausnummer')
                        }
                        if(this.portNumbersSourceCommunityId==null) {
                            errors.push('Gemeinde')
                        }
                        if(this.portNumbersSourceDocumentId==null && this.portNumbersSourceType=='private') {
                            errors.push('Nummer Ausweisdokument')
                        }
                        if(this.portNumbersSourceFirstname==null && this.portNumbersSourceType=='business') {
                            errors.push('Vorname Gesetzlicher Vertreter')
                        }
                        if(this.portNumbersSourceLastname==null && this.portNumbersSourceType=='business') {
                            errors.push('Nachname Gesetzlicher Vertreter')
                        }
                        if(this.portNumbersSourceDocumentDate==null && this.portNumbersSourceType=='private') {
                            errors.push('Datum Ausweisdokument')
                        }
                    }

                    if(errors.length>0) {
                        Swal.fire({
                            title: 'Fehler',
                            html: '<b>Bitte folgende Felder prüfen:</b><br>'+errors.join("<br>"),
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return;
                    }
                    this.step = 'data';
                    jQuery("#modal-account").scrollTop(0);
                    return;
                }


                if(this.step=='data') {
                    var check = true;
                    if(this.street == null || this.street.length==0) {
                        check = false;
                    }
                    if(this.streetNumber == null || this.streetNumber.length==0) {
                        check = false;
                    }
                    if(this.communityId == null || this.communityId.length==0) {
                        check = false;
                    }
                    if(this.firstname == null || this.firstname.length==0) {
                        check = false;
                    }
                    if(this.lastname == null || this.lastname.length==0) {
                        check = false;
                    }
                    if(this.email == null || this.email.length==0) {
                        check = false;
                    }
                    if(this.phone == null || this.phone.length==0) {
                        check = false;
                    }
                    if(check==false) {
                        Swal.fire({
                            title: 'Fehler',
                            text: `Bitte gib die Anschlussadresse und den Ansprechspartner an!`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return;
                    }
                    this.step = 'confirm';
                    jQuery("#modal-account").scrollTop(0);
                    return;
                }

                if(this.step=='confirm') {
                    if(!this.agb) {
                        Swal.fire({
                            title: 'Fehler',
                            text: `Bitte akzeptiere die AGBs!`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return
                    }

                    Swal.fire({
                        title: 'VOIP-Bestellung',
                        text: `Möchtest du die Bestellung wirklich absenden?`,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Ja',
                        confirmButtonColor: '#6bc100',
                        cancelButtonText: 'Abbrechen',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.fire({
                                title: 'VOIP-Bestellung',
                                text: 'Bitte um einen Moment Geduld - die Bestellung wird gerade versendet.',
                                allowOutsideClick: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                                onBeforeOpen: () => {
                                    Swal.showLoading()
                                },
                            });
                            var postData = {
                                street: this.street,
                                firstname: this.firstname,
                                lastname: this.lastname,
                                email: this.email,
                                phone: this.phone,
                                streetNumber: this.streetNumber,
                                product: this.$root.selectedProduct,
                                community: this.community,
                                notes: this.notes,
                                customer: this.customer,

                                hasFiberOrder: this.hasFiberOrder,
                                voipCosts: this.voipCosts,
                                newNumberFee: this.newNumberFee,
                                monthlyFee: this.monthlyFee,

                                emailFax: this.emailFax,
                                voipChannelsCount: this.voipChannelsCount,
                                phoneEntry: this.phoneEntry,
                                newNumbersCount: this.newNumbersCount,
                            }

                            if(this.portNumbers===true) {
                                var portData = {
                                    fee: this.portNumberFee,

                                    numbers: this.portNumbersNumbers,
                                    type: this.portNumbersSourceType,
                                    name: this.portNumbersSourceName,
                                    firstname: this.portNumbersSourceFirstname,
                                    lastname: this.portNumbersSourceLastname,
                                    provider: this.portNumbersSourceProvider,
                                    taxNumber: this.portNumbersSourceTaxNumber,
                                    vatNumber: this.portNumbersSourceVatNumber,
                                    street: this.portNumbersSourceStreet,
                                    streetNumber: this.portNumbersSourceStreetNumber,
                                    community: this.portNumbersSourceCommunity,
                                    documentId: this.portNumbersSourceDocumentId,
                                    documentDate: this.portNumbersSourceDocumentDate,
                                }
                                postData.port = portData
                            }


                            axios.post('/api/backend/order/voip', postData)
                                .then((response) => {
                                    console.log(response)
                                    jQuery('#modal-account').modal('hide');
                                    this.street = null;
                                    this.agb = false;
                                    this.streetNumber = null;
                                    this.communityId = null;
                                    this.notes = null;
                                    this.step= 'voip';
                                    this.portNumbers= null;
                                    this.portNumbersNumbers= [
                                        {
                                            number: null
                                        }
                                    ];
                                    this.portNumbersSourceType= null;
                                    this.portNumbersSourceName= null;
                                    this.portNumbersSourceFirstname= null;
                                    this.portNumbersSourceLastname= null;
                                    this.portNumbersSourceProvider= null;
                                    this.portNumbersSourceTaxNumber= null;
                                    this.portNumbersSourceVatNumber= null;
                                    this.portNumbersSourceStreet= null;
                                    this.portNumbersSourceStreetNumber= null;
                                    this.portNumbersSourceCommunityId= null;
                                    this.portNumbersSourceDocumentId= null;
                                    this.portNumbersSourceDocumentDate= null;

                                    this.voipChannelsCount= null;
                                    this.phoneEntry= null;
                                    this.newNumbersCount= null;
                                    window.vueApp.selectedProduct = null;
                                    this.copyCustomerData()
                                    Swal.fire(
                                        'VOIP-Bestellung',
                                        'Vielen Dank für deine Bestellung! Ein Mitarbeiter wird sich bald bei dir melden.',
                                        'success'
                                    )
                                }).catch( (error) => {
                                    Swal.fire(
                                        'VOIP-Bestellung',
                                        'Es ist ein Fehler beim Absenden der Bestellung aufgetreten! Bitte versuche es später nocheinmal oder kontaktiere uns.',
                                        'error'
                                    )
                                });
                        }
                    })
                }
            },
            copyAddressFromInvoiceAddress: function() {
                this.communities.forEach(item => {
                    if(item.id == this.customer.community_id) {
                        this.communityId = this.customer.community_id;
                    }
                })
                if(this.communityId==null) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `Hoppla! Ein unbekannter Fehler beim Kopieren ist passiert!`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return;
                }
                this.street = this.customer.street;
                this.streetNumber = this.customer.street_number;
            }
        }
    }
</script>
